import { jsx as _jsx } from "react/jsx-runtime";
import { CustomIcon } from 'shared/components/icon/custom';
import AccountIconVip from 'console/left-menu/header/icons/crown.svg';
import GradeIcon from '@mui/icons-material/Grade';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
export const iconDefaultAccount = (theme) => {
    const arrEl = [
        {
            title: 'is_vip',
            sx: {
                bgcolor: '#ffce30',
                width: 32,
                height: 32,
            },
            component: (_jsx(CustomIcon, { Icon: AccountIconVip, sx: { color: theme.palette.text.primary } })),
        },
        {
            title: 'is_worker',
            sx: {
                bgcolor: theme.palette.success.main,
                width: 32,
                height: 32,
            },
            component: _jsx(GradeIcon, { sx: { color: theme.palette.text.primary } }),
        },
        {
            title: 'has_user_paid_tariff',
            sx: {
                bgcolor: theme.palette.primary.main,
                width: 32,
                height: 32,
            },
            component: _jsx(RocketLaunchIcon, { sx: { color: theme.palette.text.primary } }),
        },
    ];
    return arrEl;
};
